<template>
  <div class="d-flex mb-3">
    <article class="card">
      <div class="py-4 px-3">
        <p class="type-h14 typo-regular text-light-high mb-3">
          Page loading
          <SettingTooltip v-if="tooltip" :title="`${tooltip}`" />
        </p>
        <div class="d-flex flex-column align-items-center">
          <img :src="thumbnailOn" class="mb-2" />
          <p class="typo-h16 weight-500 text-light-high update-plan__heading">A great choice to speed up your pages</p>
          <p class="typo-p14 text-light-low mb-5">This feature is only available in Professional and Advanced plans.</p>
          <a
            target="_blank"
            :data-href="pricingUrl"
            class="gp-open-new-tab d-flex align-items-center update-plan__link">
            <span class="update-plan__link-text">See Plan</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.3337 13.3332H4.00033C3.26395 13.3332 2.66699 12.7362 2.66699 11.9998V4.6665C2.66699 3.93012 3.26395 3.33317 4.00033 3.33317H6.66699V4.6665H4.00033V11.9998H11.3337V9.33317H12.667V11.9998C12.667 12.7362 12.07 13.3332 11.3337 13.3332ZM7.80033 9.13784L6.86033 8.19517L11.0557 3.99984H8.66699V2.6665H13.3337V7.33317H12.0003V4.94317L7.80033 9.13784Z"
                fill="#3C67FF" />
            </svg>
          </a>
        </div>
      </div>
    </article>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SettingTooltip from './SettingTooltip.vue';
import goToPricing from '@/mixins/goToPricing';

/* eslint-disable vue/no-unused-components */
export default defineComponent({
  name: 'LazyLoadingUpdatePlan',
  components: {
    SettingTooltip,
  },
  mixins: [goToPricing],
  props: {
    title: {
      type: String,
      default: '',
    },
    tooltip: {
      type: [String, Boolean],
      default: '',
    },
    thumbnailOn: {
      type: String,
      default: '',
    },
    value: Boolean,
  },
  data: () => ({}),
});
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.card {
  @include trans-all;
  position: relative;
  background: $light1;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: $radius;
  min-height: 220px;
}

.update-plan {
  &__link {
    &:visited,
    &:hover,
    &:active {
      color: $mono3;
    }

    &-text {
      margin-right: 0.25rem;
      color: inherit;
    }
  }

  &__heading {
    margin-bottom: 0.25rem;
  }
}
</style>
